import { render, staticRenderFns } from "./editGroupType.vue?vue&type=template&id=5b138900&"
import script from "./editGroupType.vue?vue&type=script&lang=js&"
export * from "./editGroupType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports